import { PaymentOptionInstrument } from './paymentMethods/paymentOption';

interface PaymentOptionApiResponse {
    instrument_types: Array<PaymentOptionInstrument>;
    type: string;
}

export interface ExpressCheckoutConditionsApiResponse {
    has_canned_questions?: boolean;
    has_custom_questions?: boolean;
    has_prepayment_questions?: boolean;
    has_required_canned_questions?: boolean;
    has_required_custom_questions?: boolean;
    payment_options?: Array<PaymentOptionApiResponse>;
}

export enum StatsigValueType {
    APPLE_PAY = 'Express Checkout - Apple pay',
    DEFAULT_CTA = 'Express Checkout - Default CTA',
    PAYPAL = 'Express Checkout - Paypal',
    GOOGLE_PAY = 'Express Checkout - Google pay',
}

export interface ExpressCheckoutSubmitDataType {
    isApplePay?: boolean;
    isPayPal?: boolean;
    isGooglePay?: boolean;
    statsigValue: StatsigValueType;
}

export enum ExpressPaymentMethodStatus {
    availabilityNotEvaluatedYet = 'availabilityNotEvaluatedYet',
    unavailable = 'unavailable',
    loadingScripts = 'loadingScripts',
    fullyLoaded = 'fullyLoaded',
}
